import { createRoutine } from 'redux-saga-routines';

export const fetchROPicklists = createRoutine('FETCH_RO_PICKLISTS');

export const fetchROPicklistForEdit = createRoutine('FETCH_RO_PICKLIST_EDIT');

export const fetchROPicklistForView = createRoutine('FETCH_RO_PICKLIST_VIEW');

export const createROPicklist = createRoutine('CREATE_RO_PICKLIST');

export const updateROPicklist = createRoutine('UPDATE_RO_PICKLIST');

export const updateROPicklistSorting = createRoutine(
  'UPDATE_RO_PICKLIST_SORTING'
);

export const deleteROPicklist = createRoutine('DELETE_RO_PICKLIST');
